<template>
  <BaseModal name="soundkit-pricing" :adaptive="true" :width="'100%'" :max-width="712" :height="'auto'" :scrollable="true" @before-open="beforeOpen">
    <SoundkitPricing :soundkit="soundkit" show-details />
  </BaseModal>
</template>
<script>
import BaseModal from "../base/base-modal.vue";
import BaseModalHeader from "../base/base-modal-header";
import SoundkitPricing from "./view/soundkit-pricing";
export default {
  components: { SoundkitPricing, BaseModalHeader, BaseModal },
  data() {
    return {
      soundkit: null
    }
  },
  computed: {
    soundkitsInCart() {
      return this.$store.state.cart.cart.filter(cartItem => cartItem.item.getType() === 'soundkit')
    }
  },
  watch: {
    soundkitsInCart(currentItems, previousItems) {
      if (currentItems.length >= previousItems.length) {
        this.$modal.hide('soundkit-pricing')
      }
    }
  },
  methods: {
    beforeOpen(event) {
      this.soundkit = event.params.soundkit
    }
  }
};
</script>
